import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "../../config/axios";

const GeneralContext = createContext();

export const GeneralProvider = ({ children }) => {
  // Discount Coupons
  const [discountCoupons, setDiscountCoupons] = useState(() => {
    try {
      const saved = localStorage.getItem("discountCoupons");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("discountCoupons", JSON.stringify(discountCoupons));
    } catch {}
  }, [discountCoupons]);

  // Cart Visibility
  const [isCartVisible, setIsCartVisible] = useState(false);
  const showCart = useCallback(() => setIsCartVisible(true), []);
  const hideCart = useCallback(() => setIsCartVisible(false), []);
  const toggleCart = useCallback(() => setIsCartVisible(prev => !prev), []);

  // Trigger cart API re-render
  const [renderCart, setRenderCart] = useState(0);
  const refreshCart = useCallback(() => setRenderCart(prev => prev + 1), []);

  // Extra Content
  const [extraContent, setExtraContent] = useState(null);
  const fetchExtraContent = useCallback(async () => {
    try {
      const response = await axios.get("/get-extra-content");
      setExtraContent(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching extra content:", error);
      return null;
    }
  }, []);

  return (
    <GeneralContext.Provider
      value={{
        discountCoupons,
        setDiscountCoupons,
        isCartVisible,
        showCart,
        hideCart,
        toggleCart,
        renderCart,
        refreshCart,
        setExtraContent,
        extraContent, // holds latest fetched extra content
        fetchExtraContent, // call this to fetch the API
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
};

// Custom hook to access context
export const useGeneral = () => useContext(GeneralContext);
